import type { AnalyticsIdentity } from './contract';

const ANONYMOUS_ID_KEY = 'towerarena.com.analytics.anonymous-id';
const DELETION_TOKEN_KEY = 'towerarena.com.analytics.deletion-token';
const SESSION_ID_KEY = 'towerarena.com.analytics.session-id';

function storedOrCreate(storage: Pick<Storage, 'getItem' | 'setItem'>, key: string, createId: () => string): string {
  const existing = storage.getItem(key);
  if (existing && existing.length <= 128) return existing;
  const created = createId();
  try { storage.setItem(key, created); } catch { /* Private browsing can reject persistence; the in-memory ID still works. */ }
  return created;
}

export function loadAnalyticsIdentity(
  local: Pick<Storage, 'getItem' | 'setItem'>,
  session: Pick<Storage, 'getItem' | 'setItem'>,
  createId: () => string = () => crypto.randomUUID(),
): AnalyticsIdentity {
  return {
    anonymousId: storedOrCreate(local, ANONYMOUS_ID_KEY, createId),
    deletionToken: storedOrCreate(local, DELETION_TOKEN_KEY, createId),
    sessionId: storedOrCreate(session, SESSION_ID_KEY, createId),
  };
}
